module.exports = __webpack_public_path__ + "static/media/post-img2.7824e717.jpg";